export const CONFIRM_EMAIL_PAGE_TITLE = 'ConfirmingYourEmailMessage';

export const ACTIVATE_EMAIL_SUCCESS_MESSAGE = 'YourEmailIsConfirmedMessage';
